"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Code extends mark_1.Mark {
    constructor() {
        super('code');
    }
}
exports.Code = Code;
//# sourceMappingURL=code.js.map